import _ from './require hacker'

export default _